import { Actions } from 'vuex-smart-module';
import { OrganizationsService } from '../../../services';
import OrganizationCheckGetters from './getters';
import OrganizationCheckMutations from './mutations';
import OrganizationCheckState from './state';

const organizationsService = new OrganizationsService();

export default class OrganizationCheckActions extends Actions<
  OrganizationCheckState,
  OrganizationCheckGetters,
  OrganizationCheckMutations,
  // eslint-disable-next-line no-use-before-define
  OrganizationCheckActions
> {
  async get_organizations_check(inn_organization: string) {
    try {
      this.mutations.TOGGLE_LOADING_ORGANIZATIONS(true);
      const { data } = await organizationsService.get_organization_check(inn_organization);

      this.mutations.SET_ORGANIZATIONS(data.items);
    } catch (error) {
      console.log(error);
    } finally {
      this.mutations.TOGGLE_LOADING_ORGANIZATIONS(false);
    }
  }
}
